import React from "react";
import { BarLoader } from "react-spinners";

function PageLoader() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <BarLoader color="rgb(54, 215, 183)" />
    </div>
  );
}

export default PageLoader;
